import { TrendingUp, Target, Clock, Users } from "lucide-react";

export const PhishingKeyFindings = () => {
  const findings = [
    {
      icon: TrendingUp,
      stat: "91%",
      title: "Of Cyberattacks Start with Phishing",
      description: "Email remains the primary attack vector. Attackers prefer phishing because it exploits human psychology rather than requiring technical exploits.",
      color: "text-destructive",
      bgColor: "bg-destructive/10",
    },
    {
      icon: Target,
      stat: "83%",
      title: "Of Organizations Experienced Phishing",
      description: "Proofpoint's 2024 report shows the vast majority of organizations faced at least one successful phishing attack in the past year.",
      color: "text-chart-1",
      bgColor: "bg-chart-1/10",
    },
    {
      icon: Clock,
      stat: "16 min",
      title: "Average Time to Click",
      description: "Users who fall for phishing emails typically click within 16 minutes. Speed of response is critical for security teams.",
      color: "text-chart-2",
      bgColor: "bg-chart-2/10",
    },
    {
      icon: Users,
      stat: "74%",
      title: "Involved Human Element",
      description: "Verizon's DBIR shows that human factors — being tricked, making errors, or misuse — are involved in the majority of breaches.",
      color: "text-primary",
      bgColor: "bg-primary/10",
    },
  ];

  return (
    <section className="py-8 sm:py-12">
      <h2 className="text-2xl sm:text-3xl font-display font-bold text-foreground mb-6">
        The Phishing Threat Landscape
      </h2>
      <p className="text-muted-foreground mb-8 max-w-3xl">
        Understanding the scope of the problem is the first step to building effective defenses.
      </p>

      <div className="grid md:grid-cols-2 gap-6">
        {findings.map((finding, index) => (
          <div
            key={index}
            className="bg-card rounded-xl border border-border p-6 hover:border-destructive/30 transition-colors"
          >
            <div className="flex items-start gap-4">
              <div className={`w-12 h-12 rounded-xl ${finding.bgColor} flex items-center justify-center shrink-0`}>
                <finding.icon className={`w-6 h-6 ${finding.color}`} />
              </div>
              <div>
                <div className={`text-2xl font-bold ${finding.color} mb-1`}>{finding.stat}</div>
                <h3 className="font-semibold text-foreground mb-2">{finding.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{finding.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
